module.exports = __webpack_public_path__ + "img/11.af1af7e5.jpg";